<template>
  <vs-table v-if="show" ref="table" :params="params" ></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  export default {
    name: "CategoryAccounts",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "CategoryAccounts",
          list: [],
          headers: {
            CategoryCode: {
              title: "کد دسته",
              type: "text"
            },
            CategoryType: {
              title: "عنوان دسته بندی",
              type: "text"
            },
          }
        },

      };
    },

  };
</script>

<style scoped>

</style>
